import {DataFetcher} from '@aboutyou/data-fetcher';
import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import {USP_BANNER_HEIGHT} from '../Header/constants';
import {UspBannerView} from './UspBannerView';
import {useGetHeaderUsps} from './hooks/useGetHeaderUsps';

export const UspBanner: React.FC = () => (
  <DataFetcher
    request={useGetHeaderUsps()}
    Loading={Skeleton}
    View={UspBannerView}
    Error={() => null}
  />
);

const Skeleton = () => {
  return <SkeletonBlock $height={`${USP_BANNER_HEIGHT}px`} />;
};
